import React from "react";
import { AutoBind } from "../../rule-engine-core/Common/AutoBind";
import { FlowStepSequence } from "../../rule-engine-core/Flow/Structure/FlowStepSequence";
import { FlowEditContext } from "../FlowEditContext";

interface IBaseSequenceActions {
    sequence: FlowStepSequence;
    editContext: FlowEditContext;
}

export abstract class BaseSequenceActions extends React.Component<IBaseSequenceActions> {
    @AutoBind
    onDeleteSequence() {
        this.props.editContext!.onDelete(this.props.sequence._id);
    }
}
